import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson-pack/list',
        data,
        method: 'post'
    })
};
// 获取添加修改表单详情
export const fetchInfo = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/lesson-pack/info',
        data,
        method: 'post'
    })
};
// 添加
export const addSave = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/lesson-pack/add',
        data,
        method: 'post'
    })
};
// 修改
export const modifySave = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/lesson-pack/edit',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/lesson-pack/change-status',
        data,
        method: 'post'
    })
};